import { comparer, toJS } from 'mobx';

import { LocationReactorResult } from 'bernie-client';
import { Store } from 'bernie-core';

import { DefaultRequestFields } from 'models';

// In a url, an empty array is equivalent to an empty string and a single element array is equivalent to a string of that element
const convertEmptyOrSingleElementArrayToString = param => {
  if (Array.isArray(param) && param.length < 2) {
    return param.toString();
  }

  return param;
};

export const haveQueryParamChanged = (currentParam, newParam) => {
  const convertedNewParam = convertEmptyOrSingleElementArrayToString(newParam);
  const convertedCurrentParam = convertEmptyOrSingleElementArrayToString(currentParam);

  return !comparer.structural(convertedCurrentParam, convertedNewParam);
};

type StoreWithDefaultRequestFields = Store & {
  defaultRequestFields: DefaultRequestFields;
};

export const processClientSideDefaultRequestFields = (
  isServer: boolean,
  store: StoreWithDefaultRequestFields,
  nextQuery?: Record<string, any>
): LocationReactorResult | undefined => {
  const defaultRequestFields = toJS(store.defaultRequestFields);

  let newQuery;

  if (!isServer && defaultRequestFields && Object.keys(defaultRequestFields).length > 0) {
    const validQuery =
      !nextQuery ||
      Object.keys(defaultRequestFields).some(key =>
        Boolean(!nextQuery[key] || haveQueryParamChanged(nextQuery[key], defaultRequestFields[key]))
      );

    if (validQuery) {
      newQuery = { query: defaultRequestFields, replace: true };
    }
    store.defaultRequestFields = {};
  }

  return newQuery;
};
